<template>
  <JyPagebody :activatedLoad="reloadData" class="news-list-container">
    <TemplateList title="单项内容" :activatedLoad="reloadData" lock-mode="card">
      <template v-slot:title>
        <div>单项内容 <jy-button type="primary" is-outline class="ml-4" @click="loadList">刷新</jy-button></div>
      </template>
      <div slot="card" class="h-100 p-3 bg-white">
        <el-tabs v-model="activecate">
          <template v-for="item in newscateList1">
            <el-tab-pane v-if="hasCate(item.id)" :key="item.id" :name="item.id" :label="item.name">
              <h3 class="text-center">{{ news.title }}</h3>
              <h5 v-if="news.title2" class="text-center">{{ news.title2 }}</h5>
              <div class="text-muted text-right">
                <jy-button v-if="news.id && hasPermiss('news.single.edit')" type="primary" icon="edit" @click="doEdit(news)">编辑</jy-button>
                <span v-if="news.id">最后更新：{{ news.updatetime || news.createtime || '' }}</span>
              </div>
              <hr>
              <el-alert v-if='!news.id' type="error" center>
                <strong>还没有内容</strong>
                <jy-button v-if="!news.id && hasPermiss('news.single.edit')" type="primary" icon="plus" @click="doEdit({cateid: item.id})">添加内容</jy-button>
              </el-alert>
              <div class="pt-3 d-pre" v-html="news.content || ''">

              </div>
            </el-tab-pane>
          </template>
        </el-tabs>
      </div>
    </TemplateList>
    <!-- 剪贴板 -->
    <a href="javascript:;" ref="copyBtn" :data-clipboard-text="copyUrl" style="display:none;">查看</a>
  </JyPagebody>
</template>

<script>
import { mapGetters } from 'vuex';
import * as types from '@/store/mutation-types';
import tools from 'jyutils/tools';
import list from '../mixin/list';
import Clipboard from 'clipboard';
import TemplateList from '../template-list.vue';
export default {
  components: {
    TemplateList
  },
  mixins: [tools, list],
  data() {
    return {
      activecate: null,
      clipboard: null,
      copyUrl: null
    }
  },
  computed: {
    ...mapGetters({
      newscateList: [types.BASE_LOAD.newscateList],
      reloadNews: [types.OTHER.reloadNews],
      loading: [types.BASE_LOAD.baseLoading]
    }),
    newscateList1() {
      return this.newscateList.filter(d => {
        return d.issingle;
      });
    },
    newsMap() {
      let map = {};
      this.list.forEach(d => {
        if (!map[d.cateid]) {
          map[d.cateid] = [];
        }
        map[d.cateid].push(d);
      });

      return map;
    },
    news() {
      if (!this.activecate) {
        return {};
      }
      return this.newsMap[this.activecate] && this.newsMap[this.activecate].length ? this.newsMap[this.activecate][0] : {};
    },
    listUrl() {
      return 'sys/news/listSingle';
    },
    queryData() {
      return {};
    }
  },
  watch: {
    reloadNews() {
      this.loadList();
    },
    newscateList: {
      handler: function() {
        this.setActive();
      },
      deep: true
    }
  },
  beforeDestroy () {
    this.clipboard && this.clipboard.destroy();
    this.clipboard = null;
  },
  methods: {
    setActive() {
      if (!this.activecate || this.activecate == '0') {
        if (this.newscateList1.length) {
          this.activecate = this.newscateList1[0].id;
        }
      }
    },
    listOkcb(json) {
      this.list = json;
    },
    afterList() {
      this.setActive();
    },
    reloadData() {
      if (!this.newscateList || !this.newscateList.length) {
        this.$store.dispatch(types.BASE_LOAD.newscateList);
      }
      if (!this.list || !this.list.length) {
        this.loadList();
      }
      this.clipboard && this.clipboard.destroy();
      this.clipboard = new Clipboard(this.$refs.copyBtn);
      this.clipboard.on('success', () => {
        this.$message.success('复制成功！');
      });
      this.clipboard.on('error', () => {
        // 释放内存
        this.clipboard.destroy();
        this.$message.error('复制失败，你的浏览器不支持自动复制！');
      });
    },
    doEdit(data) {
      this.editData = data || {};
      if (this.editData.id) {
        this.$router.push({name: 'news-single-edit', params: { id: this.editData.id }});
      } else {
        this.$router.push({name: 'news-single-edit', params: {cateid: this.editData.cateid || null}});
      }
    },
    doSave() {
      this.loadList();
    },
    addRoot(data) {
      this.doEdit(data);
    },
    newsUrl(item) {
      return `${this.BASEPATH}/detail/${item.id}`;
    },
    onInputFocus(e) {
      e.target.select();
    },
    onOpenLink(item) {
      this.copyUrl = this.newsUrl(item);
    },
    doCopy() {
      // 触发剪贴板点击
      this.$refs.copyBtn.click();
    },
    doDel(data) {
      this.msgbox('此操作将永久删除该记录, 是否继续?', () => {
        this.doPost({
          url: 'sys/news/del/'+ data.id,
          okcb: () => {
            this.loadList();
            this.$message.success('删除成功!');
          }
        });
      });
    }
  }
}
</script>
